import { i18n } from "@lingui/core"
import * as A from "fp-ts/Array"
import * as F from "fp-ts/function"
import { FieldValues, RegisterOptions } from "react-hook-form"
import { FieldPath } from "react-hook-form/dist/types/path"

type RegisterFormOptions<T extends FieldValues, TPath extends FieldPath<T>> = RegisterOptions<T, TPath>

export const required = <T extends FieldValues, TPath extends FieldPath<T>>(
    transId: string,
): Pick<RegisterFormOptions<T, TPath>, "required"> => ({
    required: i18n._(transId),
})

export const email = <T extends FieldValues, TPath extends FieldPath<T>>(
    transId: string,
): Pick<RegisterFormOptions<T, TPath>, "pattern"> => ({
    pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        message: i18n._(transId),
    },
})

export const merge = <T extends FieldValues = FieldValues, TPath extends FieldPath<T> = FieldPath<T>>(
    ...options: RegisterFormOptions<T, TPath>[]
) =>
    F.pipe(
        options,
        A.reduce({}, (state, curr) => ({ ...state, ...curr })),
    )
